module.exports = __webpack_public_path__ + "img/VK.31a26e4d.png";